export { default as IntegrationsPage } from './ui/Integrations';
